module.exports = __webpack_public_path__ + "img/sottocategorie_hdtool.fcd8a889.png";